var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: "106",
        height: "107",
        viewBox: "0 0 106 107",
        xmlns: "http://www.w3.org/2000/svg",
        "xmlns:svg": "http://www.w3.org/2000/svg",
        "enable-background": "new 0 0 24 24",
        version: "1.1",
        "xml:space": "preserve"
      }
    },
    [
      _c("g", { staticClass: "layer" }, [
        _c("rect", {
          attrs: {
            fill: "#ffffff",
            height: "104.94",
            id: "svg_3",
            rx: "13",
            ry: "13",
            stroke: "#999999",
            "stroke-linejoin": "round",
            "stroke-width": "0.1",
            width: "105.15",
            x: "0.49",
            y: "0.59"
          }
        }),
        _vm._v(" "),
        _c("g", { attrs: { id: "Page-1", transform: "matrix(1 0 0 1 0 0)" } }, [
          _c("g", { attrs: { id: "icons_x2F_inicio" } }, [
            _c("g", { attrs: { id: "svg_1" } }, [
              _c("path", {
                staticClass: "st1",
                attrs: {
                  fill: "#A8A8A8",
                  d:
                    "m82.77,51.41l-27.64,-26.08c-0.67,-0.67 -2,-0.67 -2.66,0l-28.3,26.08c-0.67,0.67 -0.67,2.01 0,2.67c0.33,0.33 0.67,0.67 1.33,0.67c0.33,0 1,-0.33 1.33,-0.67l4,-3.68l0,25.74c0,1 1,2.01 2,2.01l13.99,0c1,0 2,-1 2,-2.01l0,-12.04l9.66,0l0,12.04c0,1 1,2.01 2,2.01l14.32,0c1,0 2,-1 2,-2.01l0,-25.41l3.33,3.34c0.67,0.67 2,0.67 2.66,0c1,-0.67 0.67,-2.01 0,-2.67zm-9.99,22.74l-10.66,0l0,-12.04c0,-1 -1,-2.01 -2,-2.01l-13.32,0c-1,0 -2,1 -2,2.01l0,12.04l-10.32,0l0,-27.42l19.31,-17.72l19.31,18.05l0,27.08l-0.33,0z",
                  id: "svg_2"
                }
              })
            ])
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }